module.exports = __webpack_public_path__ + "static/media/15_tn.508ea145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/15_tn.jpg
// module id = 229
// module chunks = 0